import { AfterViewInit, Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { StepService } from '../components/stepper/step.service';
import { setToLocalStorage, getFromLocalStorage } from './helpers';
import { BehaviorSubject } from 'rxjs';
import { TravelService } from '../service/travel.service';
import { ConfigProvider } from 'src/app/service/config.service';

@Component({
  template: ''
})

export class BasicForm implements AfterViewInit {
  submitted$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  submitted = false;
  config: object;

  formAlias: string;
  form: FormGroup;

  stepValidator = () => this.form.valid;

  constructor(
    protected stepService: StepService,
    protected fb: FormBuilder,
    protected aldagi: TravelService,
    configProvider: ConfigProvider,
  ) {
    this.config = configProvider.getConfig();
  }

  ngAfterViewInit() {
    this.stepService.stepValidator = this.stepValidator;
  }

  onSubmit() {
    this.submitted$.next(true);
    if (this.form.valid) {
      setToLocalStorage('policy', this.formAlias, this.form.value);
      this.stepService.nextStep();
    } else {
      this.submitted = true;
    }
  }

  get formData() {
    const formValue = getFromLocalStorage('policy');
    return formValue && formValue[this.formAlias] ? formValue[this.formAlias] : {};
  }

  get policy(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

  // numberonly input
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }

    // get age after travel
    getAgeAfterTravel(dateString, travelPeriod) {
      var today = new Date(travelPeriod);
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }
}
